import { Fragment } from "react";
import { useHistory } from "react-router-dom";
import ContactForm from "./forms/ContactForm";
import NProgress from "nprogress";
import "../styles/nprogress.scss";

//Send event on successful submission
const dataLayerEvent = "successful-contact-submission";
const sendEvent = () => {
  window.dataLayer && window.dataLayer.push?.({ event: dataLayerEvent });
};

function Home(props) {
  const history = useHistory();
  return (
    <Fragment>
      <div className="main-content">
        <div className="header-into">
          <h4>
            We are here to help. Fill in the form below and we'll contact you
            within 2 business days.<br></br>Let's get you started in your
            child's education.{" "}
          </h4>
        </div>
        <ContactForm
          useTempState={false}
          postSumbit={() => {
            NProgress.done();
            sendEvent();
            history.push("/success");
          }}
          preSubmit={() => {
            NProgress.start();
          }}
        />
      </div>
    </Fragment>
  );
}

export default Home;
